export const getFrameAttrs = () => {
  let isEmbedded = false;
  let parentUrl = '';
  let embeddedUrl = '';

  try {
    isEmbedded = window.self !== window.top;
  } catch (e) {
    isEmbedded = true;
  }

  if (isEmbedded) {
    parentUrl = document.referrer;
    embeddedUrl = window.location.href;
  }

  return { isEmbedded, parentUrl, embeddedUrl };
};
